<script setup lang="ts">
const { isImpersonating, session } = useAuth()
const { data: workspace } = await useWorkspaceSettings()
</script>

<template>
  <div
    class="relative isolate flex min-h-svh w-full bg-zinc-100 max-lg:flex-col"
  >
    <MissingPaymentBadge v-if="workspace?.missing_payment" />
    <DemoBadge v-else-if="workspace?.demo" />
    <SettingsTopNavigation />
    <SettingsSidebarNavigation />
    <main
      id="main-content"
      class="flex flex-1 flex-col lg:min-w-0 lg:pt-2 lg:pr-2 lg:pb-2"
    >
      <div
        class="relative z-10 grow rounded-lg bg-zinc-50 p-4 shadow-xs ring-1 ring-zinc-950/5"
      >
        <div class="@container/main h-full px-2 md:px-6">
          <NuxtPage />
        </div>
      </div>
    </main>
    <NotificationToast />
    <ImpersonatingBadge
      v-if="session && isImpersonating"
      :email="session.user.email"
    />
    <DeveloperToolbox />
  </div>
</template>
